import { Component } from '@angular/core';
import { CoreReviewCardRendererBaseComponent } from '../../shared/core-review-card-rendere-base.component';

@Component({
  selector: 'cu-card-review-header',
  templateUrl: './card-review-header.component.html'
})
export class CardReviewHeaderComponent extends CoreReviewCardRendererBaseComponent {
  public getCardTitle(): string {
    const card = this.card;
    if (card?.config && Array.isArray(card.config.title)) {
      const index = card.iterationId;
      const replacementId = index >= 0 ? index + 1 : '';
      return (
        (
          (index !== undefined && card.config.title[index]?.replace(/ {{\$}}/g, replacementId)) ||
          card.config.title[card.config.title.length - 1]
        ).replace(/ {{\$}}/g, replacementId) ||
        (card.config.title && card.config.title[0].replace(/ {{\$}}/g, replacementId))
      );
    }

    return card.summaryTitle || card.customTitleOrDefault;
  }

  public goToPage() {
    this.workflowNavigationService.navigateToPage(this.page);
  }
}
